import React, { useRef } from "react";
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/forms/FormCreator";
import { addEditMappingSchemaFieldconfig } from "./addEditMappingSchemaField.formfields.config";
import { useState } from "react";
import { useGetAllMasterFieldCategoriesMutation, useGetAllOriginMutation } from "../../../../app/services/MasterValuationFieldsAPI";
import { useEffect } from "react";
import { mapDropdownOptions } from "../../../../components/forms/libs/data/mapDropdownOptions";
import { useLazyGetReprotTemplateFieldsByIdQuery } from "../../../../app/services/reportTemplateAPI";
import { useUpdateXmlSchemaAssignMutation } from "../../../../app/services/xmlReportAPI";
import ToastService from "../../../../services/toastService/ToastService";
import PropTypes from "prop-types";

const MappingSchemaField = (props) => {
  const formRef = useRef()
  const [xMLReportsForm, setxMLReportsForm] = useState(addEditMappingSchemaFieldconfig)
  const [mapfieldOptions, setMapfieldOptions] = useState([])

  const [getAllMasterFieldCategories, {
    isLoading: isAllMasterFieldCategoriesListLoading,
    isSuccess: isAllMasterFieldCategoriesListSuccess,
    data: allMasterFieldCategoriesData
  }] = useGetAllMasterFieldCategoriesMutation();

  const [updateXmlSchemaAssign, {
    isLoading: isUpdateXmlSchemaAssignAdding,
    isSuccess: isUpdateXmlSchemaAssignAdded,
    data: updateXmlSchemaAssignData,
  },
  ] = useUpdateXmlSchemaAssignMutation()

  const [getAllOrigin, {
    isLoading: isAllOriginLoading,
    isSuccess: isAllOriginSuccess,
    data: allOriginData
  }] = useGetAllOriginMutation();

  const [getReprotTemplateFieldsById, {
    isLoading: isgetReprotTemplateFieldsByIdLoading,
    isSuccess: isgetReprotTemplateFieldsByIdSuccess,
    data: getReprotTemplateFieldsByIdData
  }] = useLazyGetReprotTemplateFieldsByIdQuery();

  useEffect(() => {
    getAllMasterFieldCategories()
    getAllOrigin()
    const requestData = {
      ValFieldOrigin: 0,
      ValFieldCategory: "All",
      ReportTemplateID: props?.reportTemplateID,
    }
    getReprotTemplateFieldsById(requestData)
  }, [])

  const handleFormFieldChange = (dataField, value) => {
    if (dataField == "category" || dataField == "origin") {
      let req = {
        ReportTemplateID: props?.reportTemplateID,
        ValFieldCategory: value?.category?.label ?  value?.category?.label : "All",
       ValFieldOrigin:  value?.origin?.value == "All Origin" ? 0: value?.origin?.value || 0
      }
      getReprotTemplateFieldsById(req)
    }
  }


  useEffect(() => {
    if (props.isEdit && props.initData) {
      const form = { ...xMLReportsForm };
      form.initialState = {
        ...props.initData,
        xmlTemplateId: props?.selectedRow?.reportTemplateFieldID
      }
      setxMLReportsForm(form);
    } else {
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isEdit, props.initData]);

  const handleAssignClick = () => {
    const form = formRef.current.getFormData();
    const req = {
      reportTemplateFieldID: form?.xmlTemplateId.value ? form?.xmlTemplateId.value : form?.xmlTemplateId,
      xmlSchemaField: props?.selectedRow?.xmlSchemaField,
      xmlReportId: props?.xmlReportId
    }
    updateXmlSchemaAssign(req)
  }

  const handleCloseClick = () => {
    resetForm()
    setMapfieldOptions([])
    props.onClose()
  }

  const resetForm = () => {
    const form = { ...addEditMappingSchemaFieldconfig };
    form.initialState = { ...props.initData };
    setxMLReportsForm(form);
  };

  useEffect(() => {
    if (isAllMasterFieldCategoriesListSuccess && allMasterFieldCategoriesData) {
      let allCategorie = {
        label: "All",
        value: "All"
      }
      let categoryOptions = allMasterFieldCategoriesData.map((item) => {
        return {
          label: item.masterFieldCategory,
          value: item.id
        }
      })
      const updatedCategories = Array.from(new Set([allCategorie, ...categoryOptions]));
      mapDropdownOptions(
        addEditMappingSchemaFieldconfig,
        "basicDetailSection",
        "category",
        updatedCategories,
        "value",
        "label"
      );

    }
  }, [isAllMasterFieldCategoriesListSuccess, allMasterFieldCategoriesData]);


  useEffect(() => {
    if (isAllOriginSuccess && allOriginData) {
      let allOrgin = {
        label: "All Origin",
        value: "All Origin",
      }
  
      // Sort the origin data by label (originType)
      let originOptions = allOriginData
        .map((item) => ({
          label: item.originType,
          value: item.originId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
  
      // Prepend "All Origin" to the sorted list
      let updatedOrigin = [allOrgin, ...originOptions];
  
      mapDropdownOptions(
        addEditMappingSchemaFieldconfig,
        "basicDetailSection", 
        "origin",
        updatedOrigin,
        "value",
        "label"
      );
  
      let updatedForm = { ...xMLReportsForm };
      updatedForm.initialState = {
        ...updatedForm.initialState,
        origin: "All Origin",
        category: "All",
        xmlTemplateId: props?.selectedRow?.reportTemplateFieldID
      };
      setxMLReportsForm(updatedForm);
    }
  }, [isAllOriginSuccess, allOriginData]);
  
  useEffect(() => {
    if (!isgetReprotTemplateFieldsByIdLoading && isgetReprotTemplateFieldsByIdSuccess && getReprotTemplateFieldsByIdData) {
      mapDropdownOptions(
        addEditMappingSchemaFieldconfig,
        "basicDetailSection",
        "xmlTemplateId",
        getReprotTemplateFieldsByIdData,
        "reportTemplateFieldID",
        "valFieldName"
      );
      setMapfieldOptions(getReprotTemplateFieldsByIdData)
    }
  }, [isgetReprotTemplateFieldsByIdSuccess, getReprotTemplateFieldsByIdData, isgetReprotTemplateFieldsByIdLoading]);


  useEffect(() => {
    if (!isUpdateXmlSchemaAssignAdding && isUpdateXmlSchemaAssignAdded) {
      ToastService.success("schema update successfully")
      resetForm()
      props.onSuccess()
    }
  }, [isUpdateXmlSchemaAssignAdded, updateXmlSchemaAssignData])


  return (
    <>
      <div>
     {isAllOriginSuccess && isAllMasterFieldCategoriesListSuccess &&
          <FormCreator ref={formRef} config={xMLReportsForm} onColumnChange={handleFormFieldChange} />
        }
      </div>
      <div className="form-button-group">
        <Buttons
          buttonText="Cancel"
          buttonTypeClassName="btn secondary-btn"
          onClick={handleCloseClick}
        />
        <Buttons
          buttonText={"Assign Value"}
          buttonTypeClassName="btn blue-btn w-full"
          onClick={handleAssignClick}
          isLoading={isUpdateXmlSchemaAssignAdding}
        />
      </div>
    </>
  )

}

MappingSchemaField.prototype = {
  reportTemplateID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isEdit: PropTypes.bool, 
  selectedRow: PropTypes.shape({
    reportTemplateFieldID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    xmlSchemaField: PropTypes.string
  }),
  xmlReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  initData: PropTypes.shape({ }), 
  onSuccess: PropTypes.func,
}

export default MappingSchemaField